import { RubleSymbol } from '@r1-frontend/ui-react/experimental/purchase/cost/Cost/RubleSymbol';

import { IChargeCategory } from '~/src/features/payments-abn/models';

import * as ST from './styled';

interface IProps {
    category: IChargeCategory,
}

const ChargeItem = ({ category }: IProps): JSX.Element => {
    const { CategoryName, CategorySaleSum, CategorySum, CategoryTotalSum, subcategories } = category;

    return (
        <ST.ChargeDetail>
            <ST.PaymentInfo>
                <ST.PaymentName>{CategoryName}</ST.PaymentName>
                <ST.PaymentSum>
                    {!!CategorySaleSum && <span data-test='full-price'>{Math.abs(CategorySum)} {RubleSymbol}</span>}
                    {Math.abs(CategoryTotalSum)} {RubleSymbol}
                </ST.PaymentSum>
            </ST.PaymentInfo>
            <ST.PaymentDetail>
                {subcategories.map(subcategory => (
                    <li key={subcategory.SubcategoryId}>
                        <p>{subcategory.SubcategoryName}</p>
                    </li>
                ))}
            </ST.PaymentDetail>
        </ST.ChargeDetail>
    );
};

export default ChargeItem;
